import t from "react";
const a = _ref => {
  let {
    children: e,
    className: l
  } = _ref;
  return e ? t.createElement("span", {
    className: l
  }, e) : null;
};
a.displayName = "IconLeft";
export { a as IconLeft };